import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommandCenterConfiguration, CommandCenterMenuConfiguration } from 'src/app/shared/models/CommandCenterConfiguration';
import { FocuslinkService } from './focuslink.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root',
})
export class MenuService {
	appMenu: BehaviorSubject<menuModel[]> = new BehaviorSubject<menuModel[]>([]);
	coreMenu: BehaviorSubject<menuModel[]> = new BehaviorSubject<menuModel[]>([]);
	rawMenu: CommandCenterMenuConfiguration[];

	constructor(private focuslink: FocuslinkService, private userService: UserService) {}

	async loadMenuFromApi() {
		const resp = await this.focuslink.adminCommandCenterConfigurationGet(this.userService.userSubscription.value?.preferences?.menuVersion || 1);

		const menuReturn = new CommandCenterConfiguration(resp);
		console.log(menuReturn);
		this.rawMenu = [...menuReturn.menu];
		this.buildMenu(menuReturn.menu, false);
	}

	buildMenu(preMenu: CommandCenterMenuConfiguration[], returnOnly?: boolean): menuModel[] {
		preMenu = preMenu.filter(
			(menu) => this.userService.user.role >= menu.itemUserLevel && !this.userService.user.preferences.menusHidden?.some((i) => i === menu.key)
		);

		const menu: menuModel[] = preMenu.filter((i) => !i.parentKey);
		menu.forEach((p) => {
			const idx = preMenu.findIndex((i) => i.key === p.key);
			preMenu.splice(idx, 1);
			p.separator = true;
			p.items = [];
		});
		preMenu.forEach((m) => {
			let existParentIdx = menu.findIndex((i) => i.key === m.parentKey);
			if (existParentIdx !== -1) {
				menu[existParentIdx].items.push(m);
			} else {
				let found: boolean = false;
				for (let parent of menu) {
					for (let subParent of parent.items) {
						if (subParent.key === m.parentKey) {
							subParent.items ? subParent.items.push(m) : (subParent.items = [m]);
							found = true;
							break;
						}
					}
					if (found) break;
				}
				if (!found) {
					const parent: menuModel = preMenu.find((i) => i.key === m.parentKey);
					if (parent) {
						parent.items ? parent.items.push(m) : (parent.items = [m]);
					}
				}
			}
		});
		menu.forEach((parent, index) => {
			parent.items?.forEach((subParent) => {
				subParent.items?.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
			});
			parent.items?.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));

			if (parent.items?.length === 0) {
				// menu.splice(index, 1);
			}
		});

		if (returnOnly) {
			return menu;
		}

		this.appMenu.next(menu);
		return menu;
	}
}

interface menuModel {
	key?: string;
	parentKey?: string;
	separator?: boolean;
	label?: string;
	faIcon?: string;
	faIconPrefix?: string;
	icon?: string;
	sortOrder?: number;
	itemUserLevel?: number;
	description?: string;

	routerLink?: string[];
	items?: menuModel[];
}
[];
